import { Box, Typography, Card, CardContent } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import styles from "./ShowsCustomTableToolbar.module.scss";
import HealthScoreBar from "../HealthScoreBar/HealthScoreBar";

type CustomToolbarProps = {
  companyHealthScore: number;
};

const ShowsCustomTableToolbar = ({
  companyHealthScore,
}: CustomToolbarProps) => {
  return (
    <GridToolbarContainer>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 2,
          px: 1,
          borderBottom: 1,
          borderColor: "#E0E0E0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Typography variant="caption" align="center">Company Health Score</Typography>
          <Box sx={{ px: "16px", pt: .5, width: 160 }} data-cy="company-healthscore">
            <HealthScoreBar score={companyHealthScore} childType="shows"/>
          </Box>
        </Box>
      </Box>
    </GridToolbarContainer>
  );
};

export default ShowsCustomTableToolbar;
